import React from 'react'
import { T } from '@transifex/react'

import { Typography } from 'src/storybook/components'

const NONE = (
  <Typography type="secondary">
    <T _str="None" />
  </Typography>
)

export default NONE
